import { PlusIcon } from 'src/components/Icons/PlusIcon'
import type { AddressData } from 'src/sdk/checkout/data/types/orderformAPI'
import type { OrderForm as CheckoutOrderForm } from 'src/sdk/checkout/entity/orderForm'

import type { LocalAddressesPayload } from '../../domain/addressManagerReconciliation'
import { PostalCodeAddressCard } from './PostalCodeAddressCard'

interface AddressManagerListSectionProps {
  addressesCountLabel: string
  sortedAddresses: AddressData[]
  localDefaultAddressId: string | null
  localSelectedAddressId: string | undefined | null
  orderFormId: string
  syncOrderFormFn: (orderForm: CheckoutOrderForm) => void
  onEditAddress: (address: AddressData) => void
  onSelectAddress: (address: AddressData) => void
  onMakeDefaultAddress: (addressId: string | null) => void
  onUpdateLocalAddresses: (payload: LocalAddressesPayload) => void
  onStartAddingAddress: () => void
}

export function AddressManagerListSection({
  addressesCountLabel,
  sortedAddresses,
  localDefaultAddressId,
  localSelectedAddressId,
  orderFormId,
  syncOrderFormFn,
  onEditAddress,
  onSelectAddress,
  onMakeDefaultAddress,
  onUpdateLocalAddresses,
  onStartAddingAddress,
}: AddressManagerListSectionProps) {
  return (
    <div className="py-5 px-6 md:h-[calc(100%-110px)] flex flex-col border-t border-postal-divider">
      <div className="flex items-center justify-between">
        <span className="text-font-size-2 font-semibold uppercase tracking-[0.96px] text-postal-muted">
          Seus endereços
        </span>
        <span className="font-inter text-[11px] font-normal leading-[16.5px] text-postal-disabled">
          {addressesCountLabel}
        </span>
      </div>
      <ul
        role="radiogroup"
        aria-label="Endereços salvos"
        className="flex flex-col gap-2.5 mt-3 overflow-y-auto pr-2 [scrollbar-gutter:stable]"
      >
        {sortedAddresses.map((address) => (
          <PostalCodeAddressCard
            key={`${address.addressId}-${localDefaultAddressId}`}
            isDefault={address.addressId === localDefaultAddressId}
            isSelected={address.addressId === localSelectedAddressId}
            addressData={address}
            orderFormId={orderFormId}
            syncOrderFormFn={syncOrderFormFn}
            showActionsBar
            onEdit={() => {
              onEditAddress(address)
            }}
            onSelect={() => {
              onSelectAddress(address)
            }}
            onMakeDefault={() => {
              onMakeDefaultAddress(address?.addressId ?? null)
            }}
            onUpdateLocalAddresses={onUpdateLocalAddresses}
          />
        ))}
      </ul>
      <div className="w-full h-full bg-postal-page z-10 flex flex-1 items-end flex-col justify-end mt-4">
        <div
          className="w-full relative z-20 flex items-center justify-between before:content-[''] before:block before:h-[1px] before:bg-postal-divider before:flex-1 before:-ml-6 after:content-[''] after:block after:h-[1px] after:bg-postal-divider after:flex-1 after:-mr-6 mb-4"
          style={{ height: '1px' }}
        />
        <button
          type="button"
          className="flex items-center justify-center gap-2 w-full h-11 bg-postal-accent text-postal-inverse rounded-none border-0 font-semibold text-base hover:bg-postal-accent-hover transition-colors"
          onClick={onStartAddingAddress}
        >
          <PlusIcon width={16} height={16} color="#FFFFFF" /> Adicionar endereço
        </button>
      </div>
    </div>
  )
}
